/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AreaAssignmentResourceOption {
    All = '0',
    Specific = 1,
    None = 2,
}
